














import Vue from 'vue'
import Fieldset from '~/components/car/classifieds/form/fieldsets/handlers/Fieldset.vue'
import BaseFieldsetMixin from '~/components/car/classifieds/form/fieldsets/handlers/BaseFieldsetMixin.vue'
import { useNamespacedStore } from '~/compositions/store'
import { CLASSIFIED_FORM_NS } from '~/store/modules/shared/classifieds/form/state'
import { computed } from '@nuxtjs/composition-api'

export default Vue.extend({
  components: { Fieldset },
  mixins: [BaseFieldsetMixin],
  setup() {
    const { getters } = useNamespacedStore(CLASSIFIED_FORM_NS)

    const vehicleModelImage = computed(() => getters('vehicleModelImage'))
    return { vehicleModelImage }
  }
})
